!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, n = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in n) {
      var i = n[e];
      delete n[e];
      var o = {
        id: e,
        exports: {}
      };
      return t[e] = o, i.call(o.exports, o, o.exports), o.exports;
    }
    var l = new Error("Cannot find module '" + e + "'");
    throw l.code = "MODULE_NOT_FOUND", l;
  }).register = function(e, t) {
    n[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("82gMS", function(e, t) {
    var n, i, o, l;
    function r(e, t) {
      let n, i;
      const o = (...o) => {
        i ? (clearTimeout(n), n = setTimeout(() => {
          Date.now() - i >= t && (e(...o), i = Date.now());
        }, t - (Date.now() - i))) : (e(...o), i = Date.now());
      };
      return o.cancel = () => {
        clearTimeout(n), n = null, i = null;
      }, o;
    }
    n = e.exports, i = "throttle", o = function() {
      return r;
    }, Object.defineProperty(n, i, {
      get: o,
      set: l,
      enumerable: !0,
      configurable: !0
    });
  });
  var o = i("82gMS");
  customElements.get("collection-sticky-bar") || customElements.define("collection-sticky-bar", class extends HTMLElement {
    constructor() {
      super(), this.isVisible = !1, this.collectionSectionEl = this.closest(".collection-product-grid"), 
      this.actionBarEl = this.querySelector(".filter__action-bar"), this.handleScroll = (0, 
      o.throttle)(this.handleScroll.bind(this), 100), this.handleFilterDrawerChange = this.handleFilterDrawerChange.bind(this);
    }
    connectedCallback() {
      window.addEventListener("scroll", this.handleScroll);
      const e = document.getElementById("filter-level0");
      e && e.addEventListener("change", this.handleFilterDrawerChange), this.handleScroll();
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
      const e = document.getElementById("filter-level0");
      e && e.removeEventListener("change", this.handleFilterDrawerChange);
    }
    handleScroll() {
      if (console.log("hi"), !this.collectionSectionEl) return;
      const e = this.collectionSectionEl.getBoundingClientRect().bottom >= window.innerHeight;
      this.style.opacity = e ? null : "0", this.style.pointerEvents = e ? null : "none", 
      this.isVisible !== e && (this.isVisible = e, this._adjustLoadingSpinnerPosition(e));
    }
    handleFilterDrawerChange() {
      this.isVisible && this._adjustLoadingSpinnerPosition(!0);
    }
    _adjustLoadingSpinnerPosition(e) {
      const t = document.getElementById("filter-level0"), n = t?.checked;
      if (n) {
        const e = this.actionBarEl ? this.actionBarEl.offsetHeight : 0;
        return void document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "collection-sticky-bar",
            transform: `translateY(-${e}px)`
          }
        }));
      }
      if (e) {
        const e = this.offsetHeight, t = window.getComputedStyle(this), n = e + (parseInt(t.marginTop, 10) || 0) + (parseInt(t.marginBottom, 10) || 0);
        document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "collection-sticky-bar",
            transform: `translateY(-${n}px)`
          }
        }));
      } else document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
        detail: {
          source: "collection-sticky-bar",
          transform: ""
        }
      }));
    }
  });
  CollectionStickyBar;
}();